import(/* webpackMode: "eager" */ "/home/forge/marburginzahlen.marburg.de/node_modules/next/dist/client/app-dir/link.js");
